export enum eCreationState {
  NONE,
  FORCE,
  FIXED_SUPPORT,
  MOBILE_SUPPORT,
  VOID,
  MATERIAL,
}
